if (!customElements.get("homepage-video-player")) {
  customElements.define(
    "homepage-video-player",
    class HomepageVideoPlayer extends HTMLElement {
      connectedCallback() {
        this.videoType = this.dataset.videoType || "none";
        this.video = this.querySelector("video");
        this.controls = this.querySelector("[data-homepage-video-controls]");

        if (this.videoType === "native" && this.video && this.controls) {
          this.initNativeControls();
        }
      }

      initNativeControls() {
        this.playButton = this.controls.querySelector("[data-play-toggle]");
        this.progress = this.controls.querySelector("[data-progress]");
        this.timeEl = this.controls.querySelector("[data-time]");
        this.soundButton = this.controls.querySelector("[data-sound-toggle]");
        this.isSeeking = false;

        this.playButton?.addEventListener("click", () => {
          if (this.video.paused) {
            this.video.play().catch(() => {});
          } else {
            this.video.pause();
          }
        });

        this.soundButton?.addEventListener("click", () => {
          this.video.muted = !this.video.muted;
          this.updateSoundButton(!this.video.muted);
        });

        this.progress?.addEventListener("input", () => {
          this.isSeeking = true;
          const duration = this.video.duration || 0;

          if (duration > 0) {
            this.video.currentTime = (Number(this.progress.value) / 100) * duration;
          }

          this.updateTime();
        });

        this.progress?.addEventListener("change", () => {
          this.isSeeking = false;
        });

        this.video.addEventListener("play", () => this.updatePlayButton(false));
        this.video.addEventListener("pause", () => this.updatePlayButton(true));
        this.video.addEventListener("timeupdate", () => {
          if (!this.isSeeking) {
            this.updateProgress();
          }

          this.updateTime();
        });
        this.video.addEventListener("loadedmetadata", () => {
          this.updateProgress();
          this.updateTime();
        });
        this.video.addEventListener("durationchange", () => {
          this.updateProgress();
          this.updateTime();
        });

        this.updatePlayButton(this.video.paused);
        this.updateSoundButton(!this.video.muted);
        this.updateProgress();
        this.updateTime();
      }

      updatePlayButton(isPaused) {
        if (!this.playButton) {
          return;
        }

        this.playButton.classList.toggle("is-paused", isPaused);
        this.playButton.setAttribute(
          "aria-label",
          isPaused ? this.playButton.dataset.labelPlay : this.playButton.dataset.labelPause,
        );
      }

      updateSoundButton(isUnmuted) {
        if (!this.soundButton) {
          return;
        }

        this.soundButton.classList.toggle("is-unmuted", isUnmuted);
        this.soundButton.setAttribute("aria-pressed", String(isUnmuted));
        this.soundButton.setAttribute(
          "aria-label",
          isUnmuted ? this.soundButton.dataset.labelUnmuted : this.soundButton.dataset.labelMuted,
        );
      }

      updateProgress() {
        if (!this.progress) {
          return;
        }

        const duration = this.video.duration || 0;

        if (duration <= 0) {
          this.progress.value = 0;
          return;
        }

        this.progress.value = String((this.video.currentTime / duration) * 100);
      }

      updateTime() {
        if (!this.timeEl) {
          return;
        }

        const duration = this.video.duration || 0;
        this.timeEl.textContent = `${this.formatTime(this.video.currentTime)} / ${this.formatTime(duration)}`;
      }

      formatTime(seconds) {
        if (!Number.isFinite(seconds) || seconds < 0) {
          return "0:00";
        }

        const totalSeconds = Math.floor(seconds);
        const minutes = Math.floor(totalSeconds / 60);
        const remainingSeconds = totalSeconds % 60;

        return `${minutes}:${String(remainingSeconds).padStart(2, "0")}`;
      }
    },
  );
}
